exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-48cedfeb] .el-dialog__body{padding:0 20px\n}\n", "", {"version":3,"sources":["D:/地质云项目/DZYWebUI/src/components/LrDialog/index.vue"],"names":[],"mappings":";AACA,mCAAmC,cAAc;CAChD","file":"index.vue","sourcesContent":["\n[data-v-48cedfeb] .el-dialog__body{padding:0 20px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48cedfeb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LrDialog/index.vue
// module id = yZWh
// module chunks = 78